function add_to_cart_grid(variantid,qty){
    var id = variantid;
    var q = qty;
    fetch('/cart/add.js', {
      method: 'POST',
      body: "quantity=" + q + "&id=" + id,
      dataType: "json",
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {
      if (data.status === 422) {
        this.error(data);
      } else {
        var cart = new theme.CartDrawer;
        cart.init();
        cart.open();
      }
    }.bind(this));
}

setTimeout(function(){
  var playerElements = document.querySelectorAll('.video-placeholder');

    playerElements.forEach(function (element) {
      var videoId = element.getAttribute('data-video-id');
      var player;

      var options = {
        height: '360',
        width: '640',
        videoId: videoId,
        playerVars: {
          'autoplay': 0,
          'controls': 1,
          'rel': 0
        },
        events: {
          'onReady': function (event) {
            player = event.target;
          }
        }
      };

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            player = new YT.Player(element, options);
            observer.unobserve(element);
          }
        });
      });

      observer.observe(element);
    });
}, 1000);

function stickyheader(){
  var lastScroll = 0;

  window.onscroll = function() {
      var x = window.matchMedia("(max-width: 767px)");
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop; // Get Current Scroll Value


     if (currentScroll > 250 ){
          document.getElementById("SiteHeader").classList.add("site-header--opening");
          document.getElementById("SiteHeader").classList.add("site-header--stuck");
        }else{
         document.getElementById("SiteHeader").classList.remove("site-header--opening");
          document.getElementById("SiteHeader").classList.remove("site-header--stuck");
        }  
  };
}
stickyheader();

function recentlyFunction() {
  
    if (document.getElementById("recently_view_section").classList.contains("is_active")) {
      document.getElementById("recently_view_section").classList.remove("is_active");   
    }
    else {
      document.getElementById("recently_view_section").classList.add("is_active");
        
    }

}

